/**
 * @generated SignedSource<<76dc54b2573c79e17fca7912189a3383>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type moduleRating_ContentSubmissionFragment$data = {
  readonly learnOpportunity: {
    readonly root: {
      readonly id: string;
    } | null;
  } | null;
  readonly " $fragmentType": "moduleRating_ContentSubmissionFragment";
};
export type moduleRating_ContentSubmissionFragment$key = {
  readonly " $data"?: moduleRating_ContentSubmissionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"moduleRating_ContentSubmissionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "moduleRating_ContentSubmissionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LearnOpportunityV2",
      "kind": "LinkedField",
      "name": "learnOpportunity",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LearnOpportunityV2",
          "kind": "LinkedField",
          "name": "root",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentSubmission",
  "abstractKey": null
};

(node as any).hash = "3be689020343fa061775315af4fd01ff";

export default node;
